import React from 'react';
import './Icon.css';

const paths = {
  clipboard: (
    <>
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
    </>
  ),
  warning: (
    <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
  ),
  edit: (
    <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  ),
  trash: (
    <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  ),
  ban: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M5.5 5.5l13 13" />
    </>
  ),
  eye: (
    <>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  document: (
    <>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <path d="M14 2v6h6" />
    </>
  ),
  chart: (
    <>
      <path d="M18 20V10" />
      <path d="M12 20V4" />
      <path d="M6 20v-6" />
    </>
  ),
  spinner: (
    <path d="M12 2v4m0 12v4m10-10h-4M6 12H2m15.364-6.364l-2.828 2.828M9.464 14.536l-2.828 2.828m0-11.314l2.828 2.828m5.656 5.656l2.828 2.828" />
  ),
  check: (
    <path d="M5 13l4 4L19 7" />
  ),
  checkCircle: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  refresh: (
    <path d="M4 4v6h6M20 20v-6h-6M5 19A9 9 0 0019 8l1-2M19 5A9 9 0 005 16l-1 2" />
  ),
  shield: (
    <path d="M12 3l8 3v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3z" />
  ),
  mail: (
    <path d="M4 6h16v12H4V6zm0 0l8 6 8-6" />
  ),
  briefcase: (
    <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2m-10 0h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2z" />
  ),
  building: (
    <path d="M4 21V5a1 1 0 011-1h8a1 1 0 011 1v16M9 21V9m4 12V9M4 21h16M16 21V10h3a1 1 0 011 1v10" />
  ),
  lock: (
    <path d="M7 11V8a5 5 0 0110 0v3m-11 0h12v10H6V11z" />
  ),
  key: (
    <path d="M15 7a4 4 0 11-4 4H7v3H4v3h6v-4a4 4 0 015-6z" />
  ),
  lightbulb: (
    <path d="M9 18h6m-5 3h4M8 10a4 4 0 118 0c0 1.5-.8 2.6-1.8 3.4-.6.5-1.2 1.2-1.2 2.1h-2c0-.9-.6-1.6-1.2-2.1C8.8 12.6 8 11.5 8 10z" />
  ),
  close: (
    <path d="M6 18L18 6M6 6l12 12" />
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 10v6m0-10h.01" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  palette: (
    <path d="M12 3a9 9 0 100 18h1.5a1.5 1.5 0 000-3H13a2 2 0 01-2-2v-.5a2.5 2.5 0 012.5-2.5H17a4 4 0 00-5-10z M7.5 10.5h.01M10 7.5h.01M14 7.5h.01M16.5 10.5h.01" />
  ),
  device: (
    <path d="M7 2h10a1 1 0 011 1v18a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1zm5 17h.01" />
  ),
  accessibility: (
    <>
      <circle cx="12" cy="5" r="2" />
      <path d="M6 9h12M12 9v6m-4 6l2-6h4l2 6" />
    </>
  ),
  zap: (
    <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
  moon: (
    <path d="M21 14.5A8.5 8.5 0 119.5 3a7 7 0 0011.5 11.5z" />
  ),
  star: (
    <path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.3 6.2 21l1.1-6.5L2.6 9.8l6.5-.9L12 3z" />
  ),
  starOutline: (
    <path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.3 6.2 21l1.1-6.5L2.6 9.8l6.5-.9L12 3z" />
  ),
};

/**
 * Icono SVG inline (estilo trazo), reemplazo de emojis en UI.
 * @param {'clipboard'|'warning'|'edit'|'trash'|'ban'|'eye'|'document'|'chart'|'spinner'|'check'|'checkCircle'|'refresh'|'shield'|'mail'|'briefcase'|'building'|'lock'|'key'|'lightbulb'|'close'|'info'|'clock'|'palette'|'device'|'accessibility'|'zap'|'target'|'moon'|'star'|'starOutline'} name
 */
function Icon({ name, className = '', size = 18, title, spin = false, solid = false }) {
  const content = paths[name];
  if (!content) return null;

  return (
    <svg
      className={`ui-icon ${spin ? 'ui-icon--spin' : ''} ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={solid ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={solid ? 0 : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {content}
    </svg>
  );
}

export default Icon;
